{
    "l_first_name": "Nome",
    "l_last_name": "Cognome",
    "l_sex": "Sesso",
    "l_year_born": "Anno di nascita",
    "l_occupation": "Occupazione",
    "l_no_results": "Nessun risultato trovato",
    "l_condition_include": "include",
    "l_search_settings": "Impostazioni di ricerca",
    "l_male": "maschio",
    "l_female": "femmina",
    "l_academic_title": "Titolo accademico",
    "l_confession": "Confessione",
    "l_dienstgrad": "Grado militare",
    "l_deceived": "Deceduto",
    "l_wohnorte": "Luoghi di residenza",
    "l_buergerorte": "Luoghi di cittadinanza",
    "l_directories": "Repertori",
    "l_remarks": "Osservazioni",
    "l_sources": "Fonti",
    "l_parties": "Partiti",
    "l_einsitze": "Seggi",
    "l_conncetions": "Connessioni",
    "l_picture": "Immagine",
    "l_functions": "Funzioni",
    "l_function": "Funzione",
    "l_dict_dnb": "Catalogo della Biblioteca nazionale tedesca",
    "l_dict_hls": "Dizionario storico della Svizzera (DHS)",
    "l_time_join": "Data di adesione",
    "l_time_exit": "Data di uscita",
    "l_wahlkreis": "Circoscrizione elettorale",
    "l_wahlkreise": "Circoscrizioni elettorali",
    "l_from": "da",
    "l_until": "fino a",
    "l_since": "da",
    "l_fraktion": "Gruppo parlamentare",
    "l_fraktionen": "Gruppi parlamentari",
    "l_all": "tutti",
    "l_born_before": "Nato prima",
    "l_born_after": "Nato dopo",
    "l_party_membership": "Appartenenza a un partito",
    "l_short_name": "Nome abbreviato",
    "l_mandates": "Mandati",
    "l_political_activities": "Attività politiche",
    "l_email": "Email",
    "l_email_private": "Email privato",
    "l_mobile": "Mobile",
    "l_mobile_private": "Mobile privato",
    "l_telephone": "Telefono",
    "l_telephone_private": "Telefono privato",
    "l_address": "Indirizzo",
    "l_anrede": "Saluto",
    "l_party": "Partito",
    "l_zip_code": "Codice postale",
    "l_spouse": "Coniuge",
    "l_zivilstand": "Stato civile",
    "l_search": "cerca",
    "l_reset": "ripristina",
    "l_männlich": "maschio",
    "l_weiblich": "femmina",
    "l_gremium": "Collegio",
    "l_title": "Titolo",
    "l_type": "Tipo",
    "l_date": "Data",
    "l_time": "Ora",
    "l_traktanden": "Punti all'ordine del giorno",
    "l_number_short": "N.",
    "l_documents": "Documenti",
    "l_video": "Video",
    "l_members": "Membri",
    "l_additional_infos": "Informazioni aggiuntive",
    "l_kommission": "Commissione",
    "l_kommissionen": "Commissioni",
    "l_sitzungen": "Sedute",
    "l_contact_data": "Dati di contatto",
    "h1_fraktionen": "Gruppi parlamentari",
    "h1_kommissionen": "Commissioni",
    "h1_mitglieder": "Membri",
    "h1_sitzungen": "Sedute del Consiglio cantonale e delle commissioni",
    "h1_wahlkreise": "Circoscrizioni elettorali del Canton Zurigo",
    "h1_personen": "Membri del Consiglio cantonale di Zurigo dal 1803",
    "h1_kantonsrat": "Consiglio cantonale",
    "st_search_persons": "Ricerca persone",
    "l_data": "Dati",
    "l_ort": "Luogo",
    "l_geschaefts_art": "Tipo di affare",
    "h1_geschaefte": "Affari",
    "l_pendent_bei": "In attesa presso",
    "l_beginn": "Inizio",
    "l_role": "Ruolo",
    "l_participation": "Partecipazione",
    "l_direktion": "Direzione",
    "l_politische_gemeinde": "Comune politico",
    "l_ablauf": "Svolgimento",
    "l_status": "Stato",
    "l_frist": "Termine",
    "l_sitzungs_datum": "Data della seduta",
    "l_geschaefte": "Affari"
}